export default __webpack_public_path__ + "static/media/drama-round-a-voter.595614e9.svg";